import { Component, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {
  constructor(
    private modalService: BoobleModalService
  ) { }

  ngOnInit() { }

  closeModal() {
    this.modalService.dismiss(null);
  }

}